export function newProductExecuteWaitAdvisory(elapsedSeconds: number): string {
  const wholeSeconds = Math.max(0, Math.floor(elapsedSeconds));
  const secondsLabel = wholeSeconds === 1 ? "1 second" : `${wholeSeconds} seconds`;
  return `Running for ${secondsLabel}. About 60 seconds is typical. Do not refresh or close this tab.`;
}
